export default "__VITE_ASSET__c04be3fc__"